// Plan 07-01 (deferred-items P1 해소 동반): TS 5.7 + Node 22 에서 ESNext module
// + resolveJsonModule=true 조합일 때 JSON default import 는 `with { type: 'json' }`
// import attribute 가 없으면 TS1543 진단을 낸다 (tc39 import-attributes stage-3 표준).
// `with { type: 'json' }` 을 명시하여 빌드/typecheck 양쪽 green.
import defaultJson from './default.theme.json' with { type: 'json' };
import minimalJson from './presets/minimal.theme.json' with { type: 'json' };
import retroArcadeJson from './presets/retro-arcade.theme.json' with { type: 'json' };
import neonSynthJson from './presets/neon-synth.theme.json' with { type: 'json' };
import paperJson from './presets/paper.theme.json' with { type: 'json' };
import { themeSchema } from '../theme.js';
/**
 * 번들링된 공식 테마. 빌드 시점 검증(parse)을 거쳐 런타임 crash 내성 확보.
 * 실패하면 즉시 throw — 공식 프리셋이 스키마와 어긋나는 건 치명적 버그.
 */
function bundled(raw, slot) {
    const parsed = themeSchema.safeParse(raw);
    if (!parsed.success) {
        throw new Error(`[loop/shared] 번들 테마 "${slot}"가 theme v1.0.0 스키마와 어긋납니다:\n` +
            parsed.error.issues.map((i) => `  - ${i.path.join('.')}: ${i.message}`).join('\n'));
    }
    return parsed.data;
}
export const defaultTheme = bundled(defaultJson, 'default');
export const minimalTheme = bundled(minimalJson, 'minimal');
export const retroArcadeTheme = bundled(retroArcadeJson, 'retro-arcade');
export const neonSynthTheme = bundled(neonSynthJson, 'neon-synth');
export const paperTheme = bundled(paperJson, 'paper');
export const THEME_PRESETS = {
    default: defaultTheme,
    minimal: minimalTheme,
    'retro-arcade': retroArcadeTheme,
    'neon-synth': neonSynthTheme,
    paper: paperTheme,
};
/**
 * 최종 방어선. parseTheme의 fallback이 또 망가져도 절대 crash되지 않는
 * 최소한의 테마. 빌드된 번들에는 이미 defaultTheme가 들어있으므로 이 함수는
 * 유닛 테스트와 엣지 케이스 방어용.
 */
export const absoluteFallbackTheme = {
    schemaVersion: '1.0.0',
    name: 'Absolute Fallback',
    typography: {
        fontFamily: { text: 'sans-serif', number: 'monospace' },
        fontSize: { sm: 14, base: 18, lg: 32 },
        fontWeight: { regular: 500, bold: 700 },
        letterSpacing: 0,
        webfontUrl: null,
    },
    color: {
        background: 'transparent',
        accent: '#FFFFFF',
        text: '#FFFFFF',
        stroke: 'rgba(0,0,0,0.4)',
        glow: null,
        tiers: { small: '#FFFFFF', medium: '#FFFFFF', large: '#FFFFFF' },
    },
    shape: {
        borderRadius: 0,
        borderWidth: 0,
        padding: { toast: 12, card: 16 },
        gap: 8,
        elevation: '0 2px 8px rgba(0,0,0,0.4)',
    },
    motionPreset: 'snap',
    soundPreset: 'silent',
    tiers: { thresholds: [5000, 50000], labels: ['small', 'medium', 'large'] },
};
//# sourceMappingURL=index.js.map